import { useState, useRef, useEffect, useContext } from 'react';
import { Modal, Box, Tabs, Tab, AppBar } from '@material-ui/core'
import { useStyles } from '../Styles/styles'
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import PaginatedTableWrapper from './PaginatedTableWrapper';
import { UserContext } from '../Contexts/UserContext';

import { useLazyQuery } from '@apollo/client';
import { GET_INITIAL_CALL_INFO } from '../Queries/GetInitialCallInfo';
import { INCIDENT_ACTIONS } from '../Actions/IncidentActions';
import { IncidentsContext } from '../Contexts/IncidentsContext'

import { VEHICLE_INCIDENT_HISTORY_QUERY } from '../Queries/VehicleIncidentHistoryQuery';
import { parseVehicleIncidentHistory, parseVehicleTicketHistory, vehicleIncidentHistoryHeaders, vehicleTicketHistoryHeaders } from '../utils/VehicleHistoryHelper';
import { VEHICLE_TICKET_HISTORY_QUERY } from '../Queries/VehicleTicketHistoryQuery';
import { GET_TICKET } from '../Queries/GetTicket';
import { TICKET_ACTIONS } from '../Actions/TicketActions';
import { localGetData, localStoreData } from '../utils/utils';
import useUpdateOpenArray from '../CustomHooks/useUpdateOpenArray';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const AntTabs = withStyles({
  root: {
    borderBottom: 'none',
  },
  indicator: {
    display: 'none',
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    backgroundColor: 'lightgrey',
    '&:hover': {
      color: '#d9833b',
      opacity: 1,
    },
    '&$selected': {
      color: 'white',
      backgroundColor: 'rgb(48, 62, 79)',
      fontWeight: theme.typography.fontWeightMedium,
      border: 'none',
      '& > span > div > svg': {
        color: 'white',
        '&:hover': {
          color: '#d9833b !important'
        },
      },

    },
    marginRight: '5px'
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const VehicleHistoryModal = ({ modalOpen, setModalOpen, vehicle }) => {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const { user, responseErrorHandler } = useContext(UserContext)
  const { incidentDispatch, incidents, setFocusTab, tickets, people, ticketDispatch } = useContext(IncidentsContext)
  const { SET_INITIAL_CALL_INFO } = INCIDENT_ACTIONS;
  const tabWrapperRef = useRef(null)
  const { SET_TICKET_INFO } = TICKET_ACTIONS;
  const [dashSize, setDashSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  })

  const handleUpdateOpenTickets = useUpdateOpenArray(user);

  useEffect(() => {
    if (modalOpen && tabWrapperRef?.current?.offsetHeight) {
      setDashSize({
        width: tabWrapperRef.current.offsetWidth,
        height: tabWrapperRef.current.offsetHeight,
      });
    }
  }, [modalOpen])

  useEffect(() => {
    function handleResize() {
      tabWrapperRef.current && setDashSize({
        width: tabWrapperRef.current.offsetWidth,
        height: tabWrapperRef.current.offsetHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [getCallInfo] = useLazyQuery(GET_INITIAL_CALL_INFO, {
    context: { serializationKey: "incidentQueue" },
    variables: { originatorId: user?.id },
    fetchPolicy: "network-only",
    onError: (error) => {
      console.error(JSON.stringify(error))
    },
    onCompleted: (data) => {
      if (data) {
        responseErrorHandler(data)
        incidentDispatch({ type: SET_INITIAL_CALL_INFO, payload: data })
        handleIncidentOpening(data.initialCallInfo.id)
      }
    }
  })

  const [getTicketInfo] = useLazyQuery(GET_TICKET, {
    context: { serializationKey: "incidentQueue" },
    variables: { originatorId: user?.id },
    fetchPolicy: "network-only",
    onError: (error) => {
      console.error(JSON.stringify(error))
    },
    onCompleted: (data) => {
      if (data) {
        responseErrorHandler(data)
        ticketDispatch({ type: SET_TICKET_INFO, payload: data })
        handleTicketOpening(data.getTicket.id, false)
      }
    }
  })

  const handleIncidentOpening = (incidentId) => {
    let index = incidents.findIndex(i => i.id === incidentId || i.uuid === incidentId)
    if (index > -1) {
      setFocusTab(prevState => {
        localStoreData(prevState, `${user?.id}-last-tab`)
        return index + 4
      })
    } else {
      getCallInfo({ variables: { incidentId: incidentId } })
      let openIncidents = localGetData(`${user?.id}-open-incidents`) || []
      if (!openIncidents.includes(incidentId) && incidentId) {
        openIncidents.push(incidentId)
        localStoreData(openIncidents, `${user?.id}-open-incidents`)
      }
    }
  }

  const handleTicketOpening = (ticketId, switchTab = true) => {
    let index = tickets.findIndex(i => i.id === ticketId || i.uuid === ticketId)
    if (index > -1) {
      if (switchTab) {
        setFocusTab(prevState => {
          localStoreData(prevState, `${user?.id}-last-tab`)
          return index + (incidents?.length || 0) + (people?.length || 0) + 4
        })
      }
    } else {
      getTicketInfo({ variables: { ticketId: ticketId } })
      handleUpdateOpenTickets(ticketId, "open", "tickets")
    }
  }

  const handleTabChange = (newValue) => {
    setValue(newValue)
    switch (newValue) {
      case 0:
        vehicleIncidentHistory({ variables: { vehicleId: vehicle?.id } })
        break;
      case 1:
        vehicleTicketHistory({ variables: { vehicleId: vehicle?.id } })
        break;

      default:
        return null;
    }
  }

  // History fetching logic

  useEffect(() => {
    if (modalOpen && value === 0) {
      vehicleIncidentHistory({ variables: { vehicleId: vehicle?.id } })
    }
    // eslint-disable-next-line
  }, [modalOpen, value, vehicle?.id])

  const [vehicleIncidentHistory, { loading: incidentHistoryLoading, data: incidentHistoryData }] = useLazyQuery(VEHICLE_INCIDENT_HISTORY_QUERY, {
    context: { serializationKey: "incidentQueue" },
    variables: { originatorId: user?.id },
    fetchPolicy: "network-only",
  })
  const [vehicleTicketHistory, { loading: ticketHistoryLoading, data: ticketHistoryData }] = useLazyQuery(VEHICLE_TICKET_HISTORY_QUERY, {
    context: { serializationKey: "incidentQueue" },
    variables: { originatorId: user?.id },
    fetchPolicy: "network-only",
  })




  return (
    <Modal
      // disableEnforceFocus
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      className={classes.modal}
      data-cy="address-history-modal"
      keepMounted={false}
    >
      <div id={"tabs-wrapper"} style={{ height: '75vh', maxWidth: '75vw' }} className={classes.tabRoot} ref={tabWrapperRef}>
        <AppBar position="static" color="default">
          <AntTabs variant="scrollable" scrollButtons="auto" value={value} onChange={(e, newValue) => handleTabChange(newValue)} aria-label="simple tabs example">
            <AntTab data-cy={'Person-incident-history-tab'} id={'Person-incident-history-tab'} style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px', border: '1px solid rgb(48, 62, 79)', borderBottom: 'none' }} label={(
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                Incident History
              </div>
            )} {...a11yProps(0)}
            />
            <AntTab data-cy={'Person-drug-history-tab'} id={'Person-drug-history-tab'} style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px', border: '1px solid rgb(48, 62, 79)', borderBottom: 'none' }} label={(
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                Ticket History
              </div>
            )} {...a11yProps(1)}
            />
          </AntTabs>
        </AppBar>
        <TabPanel id="vehicle-incident-history-tab-panel" value={value} index={0}>
          <PaginatedTableWrapper
            dashSize={dashSize}
            dashWidthPercentage={.75}
            tableHeight={dashSize?.height}
            tableName={"Vehicle Incident History"}
            headers={vehicleIncidentHistoryHeaders}
            userId={user?.id}
            paginatedQueryHandler={() => console.log('Not paginated')}
            rows={incidentHistoryData ? parseVehicleIncidentHistory(incidentHistoryData[Object.keys(incidentHistoryData)[0]], handleIncidentOpening, user?.roleNames, vehicle?.id) : []}
            loading={incidentHistoryLoading}
            error={null}
            paginated={false}
            resizable={false}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <PaginatedTableWrapper
            dashSize={dashSize}
            dashWidthPercentage={.75}
            tableHeight={dashSize?.height}
            tableName={"Vehicle Ticket History"}
            headers={vehicleTicketHistoryHeaders}
            userId={user?.id}
            paginatedQueryHandler={() => console.log('Not paginated')}
            rows={ticketHistoryData ? parseVehicleTicketHistory(ticketHistoryData[Object.keys(ticketHistoryData)[0]], handleIncidentOpening, user?.roleNames, handleTicketOpening) : []}
            loading={ticketHistoryLoading}
            error={null}
            paginated={false}
            resizable={false}
          />
        </TabPanel>
      </div>
    </Modal>
  );
}

export default VehicleHistoryModal;
